import { render } from "./ContratStepWizard.vue?vue&type=template&id=27230ae6&scoped=true"
import script from "./ContratStepWizard.vue?vue&type=script&lang=js"
export * from "./ContratStepWizard.vue?vue&type=script&lang=js"

import "./ContratStepWizard.vue?vue&type=style&index=0&id=27230ae6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27230ae6"]])

export default __exports__